import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';
import { NetworkService } from '@app/services/network/network.service';
import { AuthService } from '@app/services/auth/auth.service';
import { ErrorReportingService } from '@app/services/error-reporting/error-reporting.service';

const NETWORK_ERROR_ROUTES = ['/', '/usuarios/iniciar-sesion', '/usuarios/mi-perfil'];

function getCookie(name: string): string | null {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private networkService: NetworkService,
    private router: Router,
    private authService: AuthService,
    private errorReportingService: ErrorReportingService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = request.headers;

    if (request.url.includes(environment.urlExternalGateway)) {
      return next.handle(request);
    }

    const xsrfToken = getCookie('XSRF-TOKEN');

    if (xsrfToken) {
      headers = headers.set('X-XSRF-TOKEN', xsrfToken);
    }

    const req = request.clone({ withCredentials: true, headers });

    return next.handle(req).pipe(
      catchError((error) => {
        if (error.status === 0 && NETWORK_ERROR_ROUTES.includes(this.router.url)) {
          this.networkService.setNetworkError(true);

          const currentUser = this.authService.getCurrentUser();
          this.errorReportingService.report({
            userId: currentUser?.id ?? null,
            userEmail: 'logs@sismat.com.ar',
            route: this.router.url,
            requestUrl: req.url,
            requestMethod: req.method,
            status: error.status,
            statusText: error.statusText,
            errorMessage: error.error?.message || error?.message || null
          });
        }

        // Ignorar 401 y 404 — son flujos esperados, no bugs
        if (error.status !== 401 && error.status !== 404) {
          Sentry.captureException(new Error(`HTTP ${error.status} ${error.statusText} — ${req.method} ${req.url}`), {
            extra: {
              status: error.status,
              statusText: error.statusText,
              url: req.url,
              method: req.method,
              route: this.router.url,
              errorMessage: error.error?.message || error?.message || null
            }
          });
        }

        return throwError(() => error);
      })
    );
  }
}
